import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const dataSlice = createSlice({
  name: "delete-one-question",
  initialState: initialState,
  reducers: {
    initDeleteOneQuestion: () => {
      return { ...initialState };
    },
    startDeleteOneQuestion: (state) => {
      state.loading = true;
    },
    successDeleteOneQuestion: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    errorDeleteOneQuestion: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const {
  initDeleteOneQuestion,
  startDeleteOneQuestion,
  successDeleteOneQuestion,
  errorDeleteOneQuestion,
} = dataSlice.actions;

export default dataSlice.reducer;
